import { createFileRoute } from '@tanstack/react-router'
import { BookingLinkPage } from '@/features/booking-link'

/** C-02 Booking link (direct link; the embed code is task 08). Source and "existing only" are local state. */
export const Route = createFileRoute('/_authed/clinics/$clinicId/link')({
  component: function LinkRoute() {
    const { clinicId } = Route.useParams()
    return <BookingLinkPage clinicId={clinicId} />
  },
})
